import React from "react";

// Helper to flatten the company object
const flattenCompanyData = (data) => {
  return data.map((item) => ({
    Name: item.name,
    Email: item.contact?.email || "",
    Phone: item.contact?.phone || "",
    Website: item.contact?.website || "",
    Street: item.address?.street || "",
    City: item.address?.city || "",
    State: item.address?.state || "",
    ZipCode: item.address?.zipCode || "",
    Country: item.address?.country || "",
    Facebook: item.socialMedia?.facebook || "",
    Twitter: item.socialMedia?.twitter || "",
    Linkedin: item.socialMedia?.linkedin || "",
    Instagram: item.socialMedia?.instagram || "",
    Categories: item.categories?.join("; ") || "",
    Description: item.description || "",
    BusinessHours:
      item.businessHours
        ?.map(
          (day) =>
            `${day.day}: ${
              day.isClosed ? "Closed" : `Open ${day.open}-close ${day.close}`
            }`
        )
        .join(" | ") || "",
    Photos: item.media?.photos?.join("; ") || "",
    Logo: item.media?.logo || "",
    CompletenessScore: item.completeness?.score || "",
  }));
};

const ExportButtons = ({ data }) => {
  const exportJSON = () => {
    const flatData = flattenCompanyData(data);
    const blob = new Blob([JSON.stringify(flatData, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "export.json";
    link.click();
  };

  const exportCSV = () => {
    const flatData = flattenCompanyData(data);

    if (!flatData.length) return;

    const headers = Object.keys(flatData[0]);
    const csvRows = [
      headers.join(","), // header row
      ...flatData.map((row) =>
        headers
          .map(
            (field) => `"${(row[field] ?? "").toString().replace(/"/g, '""')}"`
          )
          .join(",")
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "export.csv";
    link.click();
  };

  return (
    <div className="flex gap-2 mt-4">
      <button
        onClick={exportJSON}
        className="bg-gray-900 text-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-700 transition"
      >
        Export JSON
      </button>

      <button
        onClick={exportCSV}
        className="bg-white text-gray-900 border border-gray-300 px-4 py-2 rounded-md hover:bg-gray-100 transition"
      >
        Export CSV
      </button>
    </div>
  );
};

export default ExportButtons;
